export default __webpack_public_path__ + "static/media/2_0102.1ca3201b.webp";